import MapWrapper from './Map';

export default MapWrapper;
